import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4862dad1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-modal" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "个人中心", -1))
const _hoisted_4 = { class: "con" }
const _hoisted_5 = { class: "span-right" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 密码：****** ")
const _hoisted_7 = { class: "span-right" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 退出 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "iconfont icon-tuichu1" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  style: {"position":"absolute","width":"100vw","height":"100vh","z-index":"2","background-color":"white","top":"-58px","right":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountModifyPassword = _resolveComponent("AccountModifyPassword")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_AccountModifyRole = _resolveComponent("AccountModifyRole")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", {
          class: "iconfont icon-guanbi",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeAccount && _ctx.closeAccount(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.user?.displayName || '--') + " ", 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.user?.mobile || '--'), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, "账号：" + _toDisplayString(_ctx.user?.username || '--'), 1),
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_popover, {
              "popper-class": "hbb-work-fff",
              visible: _ctx.modifyPasswordVisible,
              "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modifyPasswordVisible) = $event)),
              trigger: "manual",
              placement: "left",
              width: 500
            }, {
              reference: _withCtx(() => [
                _createElementVNode("b", {
                  class: "iconfont icon-mima1 icon-edit-opt",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openPasswordModal && _ctx.openPasswordModal(...args)), ["stop"]))
                })
              ]),
              default: _withCtx(() => [
                (_ctx.modifyPasswordVisible)
                  ? (_openBlock(), _createBlock(_component_AccountModifyPassword, {
                      key: 0,
                      ref: "AccountModifyPassword",
                      onCloseModify: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modifyPasswordVisible = false)),
                      onModifyPasswordEvent: _ctx.modifyPassword
                    }, null, 8, ["onModifyPasswordEvent"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["visible"])
          ]),
          _createElementVNode("span", null, "归属：" + _toDisplayString((_ctx.user as any)?.currentRole?.shopName || '--'), 1),
          _createElementVNode("span", _hoisted_7, [
            _createTextVNode(" 角色：" + _toDisplayString((_ctx.user as any)?.currentRole.name || '--') + " ", 1),
            _createVNode(_component_el_popover, {
              visible: _ctx.modifyRoleVisible,
              "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modifyRoleVisible) = $event)),
              "popper-class": "hbb-work-fff",
              trigger: "manual",
              placement: "left",
              width: 500
            }, {
              reference: _withCtx(() => [
                _createElementVNode("b", {
                  class: "iconfont icon-setting icon-edit-opt",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openRoleModal && _ctx.openRoleModal(...args)), ["stop"]))
                })
              ]),
              default: _withCtx(() => [
                (_ctx.modifyPasswordVisible)
                  ? (_openBlock(), _createBlock(_component_AccountModifyRole, {
                      key: 0,
                      ref: "AccountModifyRole",
                      onCloseModify: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modifyRoleVisible = false))
                    }, null, 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "bottom",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.safeExit && _ctx.safeExit(...args)))
      }, _hoisted_10)
    ]),
    (_ctx.modifyPasswordVisible && _ctx.needChangePassword)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11))
      : _createCommentVNode("", true)
  ], 64))
}